module.exports = __webpack_public_path__ + "assets/img/extractionTarot2.e3cbcc46.png";